import React from "react";
import { BottomNavigation } from "../header";
import { useNavigate } from "react-router-dom";
import {Avatar} from 'primereact/avatar';
import Logo from "../../../../assets/logo.png";

import { useAuthChauffeur } from "../auth";
import DriverProfile from "./profile";
export const Profile = () => {
    const { logout } = useAuthChauffeur();
    const navigate = useNavigate();


const handleLogout = () => {
        logout(); 
        navigate("/chauffeur/login");
    };

  return (
    <div>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          borderBottom: "1px solid #e5e7eb",
          height: "60px",
          backgroundColor: "#ffffff",
          zIndex: 2000,
          boxSizing: "border-box",
        }}
        className="bg-white
        px-4 py-3 flex justify-content-between align-items-center fixed top-0 left-0 w-full"
      >
        <img src={Logo} alt="Logo" style={{ width: "100px" }} />
        <Avatar
          icon="pi pi-power-off"
          shape="circle"
          className="p-overlay-badge bg-gray-100 text-gray-700"
          onClick={handleLogout}
        ></Avatar>
      </div>
      <main
        style={{
          margin: "0 auto",
          marginTop: "50px",
        }}
      >
        <DriverProfile driverId={localStorage.getItem("idChauffeur")} />
      </main>
      <BottomNavigation />
    </div>
  );
};